(function () {
    if (window.__socialMediaCarouselHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.socialMediaCarousel = window.Branch.socialMediaCarousel || {};
    window.Branch.socialMediaCarousel.sliders = window.Branch.socialMediaCarousel.sliders || {};
    window.__socialMediaCarouselHasFired = true;

    function initSocialMediaCarouselSlider(socialMediaCarouselSection, parent){
        // Swiper is loaded lazily on product pages (see _head_scripts.liquid). Wait until it's ready.
        if (typeof window.Swiper === 'undefined') {
            if (typeof window.whenSwiperReady === 'function') {
                window.whenSwiperReady(function(){ initSocialMediaCarouselSlider(socialMediaCarouselSection, parent); });
            }
            return;
        }

        let parentId = parent.getAttribute('id');
        let enable_autoscroll = socialMediaCarouselSection.getAttribute('data-enable-autoscroll') == 'true';
        let autoscroll_interval = 1000 * parseInt(socialMediaCarouselSection.getAttribute('data-autoscroll-interval'));

        let autoplay = !enable_autoscroll ? false : {delay: autoscroll_interval, disableOnInteraction: true}
        
        window.Branch.socialMediaCarousel.sliders[`${parentId}`] = new Swiper(`#${parentId} .social-media-carousel__slider`, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            autoplay: autoplay,
            freeMode: true,
            loop: false,
            navigation: {
                nextEl: `#${parentId} .social-media-carousel__nav-right`,
                prevEl: `#${parentId} .social-media-carousel__nav-left`,
            },
            breakpoints: {
                  600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                900: {
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                  },
                  1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                  },
            }
        });
    }

    function initSocialMediaCarouselVideos(socialMediaCarouselSection){
        let videos = socialMediaCarouselSection.querySelectorAll('.social-media-carousel__post-video');
        if(videos.length === 0){
            return;
        }

        // A paused <video> keeps its download and decoder, and so does every product page
        // Safari holds in its back/forward cache, all inside the tab's memory limit. Once the
        // carousel is more than a screen away, or the page is cached, take the sources off so
        // the browser drops them; restoreVideo puts them back before the next play.
        function releaseVideo(video){
            video.pause();
            let sources = video.querySelectorAll('source[src]');
            if(sources.length === 0){
                return;
            }
            sources.forEach((source) => {
                source.setAttribute('data-src', source.getAttribute('src'));
                source.removeAttribute('src');
            });
            video.preload = 'none';
            video.load();
        }

        function restoreVideo(video){
            let sources = video.querySelectorAll('source[data-src]:not([src])');
            if(sources.length === 0){
                return;
            }
            sources.forEach((source) => source.setAttribute('src', source.getAttribute('data-src')));
            video.load();
        }

        function playVideo(video){
            // Never call load() on a clip that still has its sources. It aborts the fetch
            // preload kicks off and rewinds the element, which shows up as the clip starting,
            // snapping back to frame zero, then playing through. A released clip has nothing
            // buffered, so restoreVideo reloads it.
            restoreVideo(video);
            if(video.preload === 'none'){
                video.preload = 'auto';
            }
            let playing = video.play();
            if(playing && playing.catch){
                playing.catch(() => {});
            }
        }

        if(typeof IntersectionObserver === 'undefined'){
            videos.forEach(playVideo);
            return;
        }

        let observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting){
                    playVideo(entry.target);
                } else {
                    entry.target.pause();
                }
            });
        }, {threshold: 0.35});

        videos.forEach((video) => observer.observe(video));

        let farObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(!entry.isIntersecting){
                    videos.forEach(releaseVideo);
                }
            });
        }, {rootMargin: '100% 0px'});
        farObserver.observe(socialMediaCarouselSection);

        window.addEventListener('pagehide', (event) => {
            if(event.persisted){
                videos.forEach(releaseVideo);
            }
        });
        // Observing again reports each clip's current visibility, so the ones on screen play.
        window.addEventListener('pageshow', (event) => {
            if(event.persisted){
                videos.forEach((video) => {
                    observer.unobserve(video);
                    observer.observe(video);
                });
            }
        });
    }

    function actionsOnVisible(socialMediaCarouselSection, parent){
        socialMediaCarouselSection.setAttribute('data-interacted', true);
        window.Branch.nav.handleUpdateSrcSet(null, '.social-media-carousel__post-image', '.social-media-carousel__post-image-container', 540);     
        initSocialMediaCarouselSlider(socialMediaCarouselSection, parent);
        initSocialMediaCarouselVideos(socialMediaCarouselSection);
    }

    function initSocialMediaCarouselCallback(socialMediaCarouselSection, parent, type){
        let fromLoad = socialMediaCarouselSection.closest('.homepage-content-container') && socialMediaCarouselSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';
        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(socialMediaCarouselSection, parent);
        } else if(!socialMediaCarouselSection.closest('.homepage-content-container')) {
            actionsOnVisible(socialMediaCarouselSection, parent);
        } else {
            const scrollHandler = function () {
            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const targetRect = socialMediaCarouselSection.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

                if (
                    isVisible &&
                    socialMediaCarouselSection.getAttribute("data-interacted") !== "true"
                ) {
                    actionsOnVisible(socialMediaCarouselSection, parent);
                    socialMediaCarouselSection.setAttribute("data-interacted", "true");
                    window.removeEventListener("scroll", scrollHandler);
                }
            };

            window.addEventListener("scroll", scrollHandler);
        }
    }

    window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad = function(type){
        let socialMediaCarouselSections = document.querySelectorAll('.social-media-carousel:not([data-initialized="true"])');
        socialMediaCarouselSections.forEach((socialMediaCarouselSection) => {
            let parent = socialMediaCarouselSection.closest('.shopify-section');
            socialMediaCarouselSection.setAttribute('data-initialized', true);

            if(type == 'from-copy'){
                initSocialMediaCarouselCallback(socialMediaCarouselSection, parent, type)
            } else {
                window.Branch.functions.fireOnUserInteraction(initSocialMediaCarouselCallback, '.homepage-content-container', socialMediaCarouselSection, socialMediaCarouselSection, parent);
            }

        })  
    }

    if (document.readyState === "complete") {
        window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.socialMediaCarousel.socialMediaCarouselInitOnLoad('regular'));
    }
  })();
